import { MuiChipsInput } from 'mui-chips-input';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Controller, useFormContext } from 'react-hook-form';
import { FilterIdTypes } from 'shared/mui/Filter/hooks/useIdFilters';
import { getIdsArray } from 'utils/getIdsArray';

type FilterChipsInputProps = {
  name: FilterIdTypes;
  label: string;
  notFoundIds?: string[];
};

export const FilterChipsInput: React.FC<FilterChipsInputProps> = ({ name, label, notFoundIds }) => {
  const { control } = useFormContext();
  const translate = useTypedTranslate();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <MuiChipsInput
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={label}
          placeholder={translate('app.filter.enterId')}
          size="small"
          {...field}
          error={fieldState.invalid}
          hideClearAll
          onPaste={(e) => {
            e.preventDefault();
            const newValue = getIdsArray(e.clipboardData.getData('Text')) || [];
            field.onChange([...field.value, ...newValue]);
          }}
          renderChip={(Component, key, props) => {
            return (
              <Component
                {...props}
                color={notFoundIds?.includes(props.label) ? 'warning' : undefined}
                key={key}
              />
            );
          }}
          variant="outlined"
        />
      )}
    />
  );
};
